import * as actionTypes from './actionTypes';

export const addImportantPlace = (Location, Location2, LocIcon, Lat, Lng, MapLat, MapLng, MapType, Zoom, Heading, Pitch) => {
  return {
    type: actionTypes.ADD_IMPORTANT_PLACE,
    Location,
    Location2,
    LocIcon,
    Lat,
    Lng,
    MapLat,
    MapLng,
    MapType,
    Zoom,
    Heading,
    Pitch,
  };
};

export const addImportantPlaceStart = () => {
  return {
    type: actionTypes.ADD_IMPORTANT_PLACE_START,
  };
};

export const addImportantPlaceSuccess = () => {
  return {
    type: actionTypes.ADD_IMPORTANT_PLACE_SUCCESS,
  };
};

export const addImportantPlaceFailed = (error) => {
  return {
    type: actionTypes.ADD_IMPORTANT_PLACE_FAILED,
    error,
  };
};

export const updateImportantPlace = (Id, Location, Location2, LocIcon, Delete) => {
  return {
    type: actionTypes.UPDATE_IMPORTANT_PLACE,
    Id,
    Location,
    Location2,
    LocIcon,
    Delete,
  };
};

export const updateImportantPlaceStart = () => {
  return {
    type: actionTypes.UPDATE_IMPORTANT_PLACE_START,
  };
};

export const updateImportantPlaceSuccess = () => {
  return {
    type: actionTypes.UPDATE_IMPORTANT_PLACE_SUCCESS,
  };
};

export const updateImportantPlaceFailed = (error) => {
  return {
    type: actionTypes.UPDATE_IMPORTANT_PLACE_FAILED,
    error,
  };
};

export const fetchImportantPlaces = () => {
  return {
    type: actionTypes.FETCH_IMPORTANT_PLACES,
  };
};

export const fetchImportantPlacesStart = () => {
  return {
    type: actionTypes.FETCH_IMPORTANT_PLACES_START,
  };
};

export const fetchImportantPlacesSuccess = (importantPlaces) => {
  return {
    type: actionTypes.FETCH_IMPORTANT_PLACES_SUCCESS,
    importantPlaces,
  };
};

export const fetchImportantPlacesFailed = (error) => {
  return {
    type: actionTypes.FETCH_IMPORTANT_PLACES_FAILED,
    error,
  };
};
